export const formatGBP = (amountInPence) => {
  const pounds =
    typeof amountInPence === 'number' && !Number.isNaN(amountInPence)
      ? amountInPence / 100
      : 0;

  if (pounds >= 1000) {
    const intPounds = Math.round(pounds);
    const grouped = intPounds.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `£${grouped}`;
  }

  const oneDecimal = Math.round(pounds * 10) / 10;
  return `£${oneDecimal.toFixed(0)}`;
};
